<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/sinavreadingmachine.png" alt="" />
      <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      <SsoError v-if="error" :message="error"></SsoError>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "SinavReadingMachine",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8',
      userData: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      this.userDataNew = this.userData;
      // sınıflar array geliyor
      // if (this.userData.role_type === 'student' || this.userData.roleType === 'student') {
      //   this.userDataNew.class = [
      //     {
      //       grade: this.userData.class,
      //       branch: this.userData.branch,
      //     }
      //   ];
      // } else {
      //   // classes değişkenini virgülle ayırarak sınıfları alma
      //   this.userDataNew.class = [];
      //   if (this.userData.classes) {
      //     const classArray = this.userData.classes.split(',');
      //
      //     classArray.forEach(sinif => {
      //       // İlk "-" işaretine göre grade ve branch ayırma
      //       const firstDashIndex = sinif.indexOf('-');
      //       if (firstDashIndex !== -1) {
      //         const grade = sinif.substring(0, firstDashIndex);
      //         const branch = sinif.substring(firstDashIndex + 1);
      //
      //         this.userDataNew.class.push({
      //           grade: grade,
      //           branch: branch
      //         });
      //       }
      //     });
      //   }
      // }
      this.ueslmsCheckUser();
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('SinavReadingMachine SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/sinavreadingmachine/user/check', {user: this.userDataNew})
      // axios.post('https://ueslms.test/api/v2/sinavreadingmachine/user/check', {user: this.userDataNew})
          .then(response => {
            if (response.data.success) {
              this.goSinavReadingMachine()
            } else if (response.data.message) {
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/sinavreadingmachine/user/create', this.userDataNew)
      // axios.post('https://ueslms.test/api/v2/sinavreadingmachine/user/create', this.userDataNew)
          .then(response => {
            if (response.data.success) {
              this.goSinavReadingMachine()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    async goSinavReadingMachine() {
      const password = (this.userDataNew.role_type === 'student' || this.userDataNew.roleType === 'student') ? '123456' : 'Ues1234!';
      location.href = "https://www.sinavreadingmachine.com/#/?username=" + btoa(this.userDataNew.username) + "&password=" + btoa(password);
    },

  }
}
</script>
